import type { CSSProperties } from 'react';
import { IToastIcon, IToastProps } from './Toast';
import styles from './Toast.module.css';

export enum StyleElem {
    Container = 'Container',
    Icon = 'Icon',
    Text = 'Text',
}

const DEFAULTS: Record<StyleElem, CSSProperties> = {
    [StyleElem.Container]: {},
    [StyleElem.Icon]: {},
    [StyleElem.Text]: {},
};

const PROPS_APPLICATOR: Record<StyleElem, (props: IToastProps) => CSSProperties> = {
    [StyleElem.Container]: (props: IToastProps) => ({
        backgroundColor: MapBackgroundColor(props.icon),
    }),
    [StyleElem.Icon]: (props: IToastProps) => ({
        color: MapTextColor(props.icon),
    }),
    [StyleElem.Text]: (props: IToastProps) => ({
        color: MapTextColor(props.icon),
    }),
};

function MapBackgroundColor(inIcon: IToastIcon): string {
    switch (inIcon) {
        case IToastIcon.Error:
            return '#cc0000';

        case IToastIcon.Warning:
            return '#f0ad4e';

        case IToastIcon.Success:
            return '#339900';

        case IToastIcon.Information:
            return '#000';

        default:
            throw Error('Unrecognised type: ' + inIcon);
    }
}

function MapTextColor(inIcon: IToastIcon): string {
    switch (inIcon) {
        case IToastIcon.Error:
            return '#fff';

        case IToastIcon.Warning:
            return '#fff';

        case IToastIcon.Success:
            return '#fff';

        case IToastIcon.Information:
            return '#fff';

        default:
            throw Error('Unrecognised type: ' + inIcon);
    }
}

export function classNameForElement(element: StyleElem, props: IToastProps): string {
    const name = element.toString();
    const classLoad = styles[name];
    return classLoad ?? '';
}

export function styleForElement(element: StyleElem, props: IToastProps): CSSProperties {
    const style = Object.assign({}, DEFAULTS[element], PROPS_APPLICATOR[element](props));

    return style;
}
